// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  hmr: false,
  privacyTerms: 'https://simplesign.io/terms-of-use/',
  apiUrl: 'https://prod.simplesign.io/api/',
  appUrl: 'https://app.simplesign.io/#/',
  pusherAppKey: '321cd9e5ebf00f45a5ec',
  cluster: 'eu',
  locale: {
    availableLanguages: ['en', 'sv', 'de', 'fi', 'fr', 'no', 'da', 'es', 'pl', 'sl', 'terms'],
    defaultLanguage: 'en',
    fallbackLang: "terms",
    localeUrl: "https://app.simplesign.io/"
  },
  criiptioBank:{
    redirectUri: "https://prod.simplesign.io/auth/criipto/bankid",
    clientId: "urn:my:application:identifier:1980",
    criptoDomain: "https://simplesign-international-ab.criipto.id/",
    acrValues: {
      norwegianBankId: "dXJuOmdybjphdXRobjpubzpiYW5raWQ="
    }
  },
  endUserIp: "127.0.0.1",//TODO: it should be placed in the environment file and maybe CI/CD updated as well,
  allowTokenLogins: false,
  enableBulkUpload: true ,
  enableAIBulkUpload: false,
  samlLoginUrl: "https://prod.simplesign.io/api/saml/",
  sentry: {
    enabled: true,
    dsn: "https://7bc621ca3b33ebc7c8f54a639435343b@o4508998537707520.ingest.de.sentry.io/4508998566215760",
    environment: "production"
  },
  socialLoginsURL:{
      baseURL: "https://prod.simplesign.io",
      linkedin: "/auth/social/linkedin/redirect",
      microsoft: "/auth/social/microsoft/redirect",
      google: "/auth/social/google/redirect"
  },
  hubspotTrackingId: "144265445"
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
